import { Http } from '@intelipost-js/secure-providers';

export default {
  getMarkers({ commit }) {
    return Http.get('audit/v1/markers')
      .then(res => commit('markers', res.data));
  },
  createMarker({ dispatch }, marker) {
    return Http.post('audit/v1/markers', marker)
      .then(() => dispatch('getMarkers'));
  },
  updateMarker({ dispatch }, marker) {
    return Http.put(`audit/v1/markers/${marker.id}`, marker)
      .then(() => dispatch('getMarkers'));
  },
  deleteMarker({ dispatch }, markerId) {
    return Http.delete(`audit/v1/markers/${markerId}`)
      .then(() => dispatch('getMarkers'));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/store/actions.js